<template>
  <div class="container">
    <div v-show="isVisible" class="my-xl-3 py-xl-3" :class="{

        'col-lg-12': true

    }" >

    <!--checkbox-->
    <div class="row justify-content-center" >
        <div class="col col-auto">
          <label class="form-label" > <input type="checkbox" v-model="notChecked" id="checkbox"><span style="margin-right: 10px"></span>Oświadczam, że zapoznałem się z Umową pożyczki i akceptuję jej treść. </label>
        </div>
    </div>

    <!--checkbox2-->
    <div class="row justify-content-center" >
        <div class="col col-auto">
          <label class="form-label" > <input type="checkbox" v-model="notChecked2" id="checkbox"><span style="margin-right: 10px"></span>Oświadczam, że zapoznałem się z Formularzem informacyjnym i akceptuję jego treść. </label>
        </div>
    </div>


    <div class="row justify-content-center" >
        <div class="col-lg-6 form-input" >

            <input ref="input" type="text" class="form-control " placeholder="Wprowadz kod sms" v-model="code" @input="$v.code.$touch();">

            <p v-if="$v.code.$invalid && $v.code.$dirty " style="color:red;" class="validatePassword">* Wprowadź kod sms - 6 znaków</p>   
            <p v-if="err" style="color:red;" class="validatePassword" v-dynamic="err"></p>

        </div>
    </div>






      <!--button-->
    <div class="row justify-content-center">
        <div class="col col-auto"><!--
          <button ref="submit" key="sign-button" class="SignContractButton" :disabled="!isDisabled"  @click="signContract"> {{ label }} </button>-->
          <a  key="btn-next"  :class="{
                                  disabled:!isDisabled
                                }"
              class="form-button-two btn btn-outline-primary btn-lg me-2"
              @click="signContract" > {{ label }}</a>
        </div>
    </div>

    


<!-- <main>
<div class="button" @click="onSubmit">
    <div class="text" >Submit</div>
  </div>


  <div class="progress-bar"></div>
  <svg x="0px" y="0px"
     viewBox="0 0 25 30" style="enable-background:new 0 0 25 30;">
    <path ref="check" class="check st0" d="M2,19.2C5.9,23.6,9.4,28,9.4,28L23,2"/>
  </svg>
</main> -->




    </div>
  </div>
</template>

<script>

    
    import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'; 

    import anime from 'animejs/lib/anime.es.js';



    export default {
        name: "SignContract",

       
        computed: {


            isDisabled(){
                return this.notChecked && this.notChecked2 && !this.$v.code.$invalid;
            }

        },

        

        validations(){

          return {
            code: {
             
                required,
                minLength: minLength(7),
                maxLength: maxLength(7)
              }
        
          }
        },




        data(){
            return {

                code: '',

                err: '',

                notChecked: false,
                notChecked2: false,

                isVisible: true,


                basicTimeline: anime.timeline({
                  autoplay: false
                })

            }
        },


        watch: {

            notChecked(check){

                this.$emit('consent', 'first', check);
            },


            notChecked2(check){

                this.$emit('consent', 'second', check);
            }


        },


        props: {

            loan_id: {
                type: String,
                required: true
            },


            label: {
                type: String,
                required: true
            }

        },



        methods: {


            signContract(){


                //this.basicTimeline.play();
                this.$emit('signed', this.code, this.loan_id);

            },


            onSubmit(){

               // alert('click')
//console.log('timeline is  ')

          //      console.log(this.basicTimeline)


              //  this.basicTimeline.play();


            }




        },





        created() {


            this.listen('visibility', (bind, checked ) => {

                bind.split(',').indexOf(this.name) > -1
                    && (this.isVisible = checked);
            });




        },

        mounted(){






          /*  var pathEls = this.$refs['check']; //$(".check");
            for (var i = 0; i < pathEls.length; i++) {
              var pathEl = pathEls[i];
              var offset = anime.setDashoffset(pathEl);
              pathEl.setAttribute("stroke-dashoffset", offset);
            }*/

            this.basicTimeline
             /* .add({
                targets: ".text",
                duration: 1,
                opacity: "0"
              })*/
              .add({
                targets: this.$refs['submit'], //".button",
                duration: 1300,
                height: 20,
                width: 300,
                backgroundColor: "#2B2D2F",
                border: "1",
                borderRadius: 100
              });

             /* .add({
                targets: ".progress-bar",
                duration: 2000,
                width: 300,
                easing: "linear"
              })
              .add({
                targets: ".button",
                width: 0,
                duration: 1
              })
              .add({
                targets: ".progress-bar",
                width: 80,
                height: 80,
                delay: 500,
                duration: 750,
                borderRadius: 80,
                backgroundColor: "#71DFBE"
              })
              .add({
                targets: pathEl,
                strokeDashoffset: [offset, 0],
                duration: 200,
                easing: "easeInOutSine"
              });*/

/*$(".button").click(function() {
  basicTimeline.play();
});

$(".text").click(function() {
  basicTimeline.play();
});*/







        }
    }
</script>


<style scoped>
    a{
      width: 300px;
      height: 55px;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }
  .btn-outline-primary.disabled {
    background-color: #045439;
  }
  @media (max-width:481px){
    a{
      width: 240px;
      height:55px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/SignContract.vue